
import { roomActionTypes } from './room.types';

const INITIAL_STATE = {
    room: [],
    roomInfo: {}
};

const roomReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case roomActionTypes.SET_NEW_ROOM:
            return {
                ...state,
                room: action.payload
            };

        case roomActionTypes.SET_ROOM_INFO:
            return {
                ...state,
                roomInfo: action.payload
            };

        default:
            return state;
    }
};

export default roomReducer;